import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { routes } from 'client/lib/routes';
import { Channel } from 'client/model/skill';
import { getAccessAsViewer, showAppStoreUi, showAutoAppUi } from 'client/utils';

import AllAvailableAppsByChannel from './AllAvailableAppsByChannel';

export const AllAvailableAppsRouter = () => {
    if (!getAccessAsViewer() || !showAppStoreUi()) {
        return <Navigate to={routes.app.root} replace />;
    }

    return (
        <Routes>
            <Route path="tv-apps" element={<AllAvailableAppsByChannel channel={Channel.TvApp} />} />
            <Route
                path="auto-apps"
                element={
                    showAutoAppUi() ? (
                        <AllAvailableAppsByChannel channel={Channel.AutoApp} />
                    ) : (
                        <Navigate to={routes.app.root} replace />
                    )
                }
            />
            <Route path="smart-screen" element={<AllAvailableAppsByChannel channel={Channel.SmartScreenApp} />} />
            <Route path="*" element={<AllAvailableAppsByChannel channel={Channel.TvApp} />} />
        </Routes>
    );
};
